var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed w-screen flex justify-end transition-all duration-500",
      style: {
        top: _vm.chevronOpened
          ? "calc(4.5rem + 5.75rem)"
          : "calc(100vh - 3.5rem)",
        right: _vm.open ? "0vw" : "-200vw",
        height: "calc(100vh - 4.5rem - 5.75rem)",
        zIndex: 52
      },
      attrs: { id: "new-intruction-panel" }
    },
    [
      _c("div", {
        staticClass: "h-full w-screen absolute left-0 top-0 -z-10",
        on: {
          click: function($event) {
            _vm.chevronOpened = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "h-full w-120 flex-shrink-0 flex flex-col bg-pure-white relative z-0"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "px-6 py-4 flex items-center gap-4 rounded-t-3xl bg-light-purple-300 cursor-pointer",
              on: {
                click: function($event) {
                  _vm.chevronOpened = !_vm.chevronOpened
                }
              }
            },
            [
              _vm.showIcon
                ? _c("BlIcon", {
                    staticClass: "w-5 h-5 transition-all duration-300",
                    style: { rotate: !_vm.chevronOpened ? "180deg" : "" },
                    attrs: { icon: "chevron-down", color: "secondary" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("BlTextSubtitle2", {
                staticClass: "text-pure-white",
                attrs: { text: "Create new instruction" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "relative h-full flex flex-col justify-between overflow-y-auto"
            },
            [
              _c(
                "div",
                { staticClass: "py-5 px-6 flex flex-col gap-3" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-2" },
                    _vm._l(_vm.typeOptions, function(opt) {
                      return _c(
                        "div",
                        {
                          key: opt.value,
                          staticClass:
                            "h-7.5 px-2 flex items-center gap-2 rounded-full bg-lime-100 cursor-pointer border",
                          class: [
                            opt.value === _vm.typeInput
                              ? "border-lime-600"
                              : "border-lime-100"
                          ],
                          on: {
                            click: function($event) {
                              _vm.typeInput = opt.value
                            }
                          }
                        },
                        [
                          opt.value === "notes"
                            ? _c("BlIcon", {
                                staticClass: "h-4 w-4",
                                attrs: { icon: "paper-note", color: "lime-6" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          opt.value === "todo"
                            ? _c("BlIcon", {
                                staticClass: "h-4 w-4",
                                attrs: { icon: "to-do", color: "lime-6" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-lime-700",
                            attrs: { text: opt.label }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("BlInputText", {
                    attrs: { input: _vm.titleInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _vm.chevronOpened
                    ? _c(
                        "div",
                        { staticClass: "pb-px relative" },
                        [
                          _c("VueEditor", {
                            staticClass: "blum-editor",
                            attrs: {
                              "editor-toolbar": _vm.customToolbar,
                              placeholder: "Description"
                            },
                            model: {
                              value: _vm.descriptionInput,
                              callback: function($$v) {
                                _vm.descriptionInput = $$v
                              },
                              expression: "descriptionInput"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.uploads.length
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "p-2 flex flex-col gap-2 rounded bg-slate-200"
                        },
                        _vm._l(_vm.uploads, function(upload) {
                          return _c("BlFileHolder", {
                            key: upload.lastModified,
                            attrs: {
                              name: upload.name,
                              size: upload.size,
                              removeable: ""
                            },
                            on: {
                              "remove-handler": function($event) {
                                return _vm.onRemoveDoc(upload)
                              }
                            }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex items-center justify-between" },
                    [
                      _c("input", {
                        attrs: {
                          type: "file",
                          name:
                            "new_upload_document_prospect_" +
                            _vm.prospectStage.id,
                          id:
                            "new_upload_document_prospect_" +
                            _vm.prospectStage.id,
                          hidden: ""
                        },
                        on: { change: _vm.onAddDoc }
                      }),
                      _vm._v(" "),
                      _vm.chevronOpened
                        ? _c("BlInputButton", {
                            attrs: {
                              type: "plain",
                              dense: "",
                              icon: "plus",
                              label: "Add document"
                            },
                            on: { clicked: _vm.openUpload }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.uploads.length
                        ? _c("BlTextBody2", {
                            attrs: {
                              text: _vm.uploads.length + " file(s) added"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.typeInput === "todo"
                    ? _c(
                        "div",
                        {
                          staticClass: "grid grid-cols-2 gap-y-3 gap-x-2",
                          class: { "pt-8": !_vm.uploads.length }
                        },
                        [
                          _vm.chevronOpened
                            ? _c("BlSelectBox", {
                                staticClass: "col-span-2",
                                attrs: {
                                  search: "",
                                  placeholder: "Assign to (optional)",
                                  fetchProperty: {
                                    url:
                                      "/api/v1/users?sort=name_asc&status=active&role=admin&query=",
                                    dataKey: "users",
                                    countKey: "total_users",
                                    optionKeys: { value: "id", label: "name" }
                                  },
                                  drop: "up"
                                },
                                on: {
                                  change: function($event) {
                                    _vm.assignedUserInput = $event
                                  }
                                },
                                model: {
                                  value: _vm.assignedUserInput,
                                  callback: function($$v) {
                                    _vm.assignedUserInput = $$v
                                  },
                                  expression: "assignedUserInput"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.chevronOpened
                            ? _c("BlInputDate", {
                                attrs: { input: _vm.dueDateInput },
                                on: { changed: _vm.inputHandler }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("BlInputTime", {
                            attrs: { input: _vm.dueDateTimeInput, icon: false },
                            on: { changed: _vm.inputHandler }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "h-18 px-6 pt-4 sticky bottom-0 flex-shrink-0 bg-pure-white grid"
                },
                [
                  _c("BlInputButton", {
                    attrs: {
                      label: "Create",
                      disabled: _vm.isDisabledSubmit,
                      loading: _vm.submitLoading
                    },
                    on: { clicked: _vm.onCreate }
                  })
                ],
                1
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fbad660", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fbad660","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/prospectPanel/NewInstructionProspectPanel.vue
// module id = null
// module chunks = 